import React from "react";
import { Link as RouterLink } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import PlaceIcon from "@mui/icons-material/Place";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import ScheduleIcon from "@mui/icons-material/Schedule";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import SocialIconButton from "../components/SocialIconButton";
import content from "../content.json";

const { business, serviceCatalog } = content;

export default function Footer() {
  return (
    <Box component="footer" sx={{ backgroundColor: "dark.main", color: "white.main", mt: 6 }}>
      <Box
        sx={{
          maxWidth: "1536px",
          width: "100%",
          mx: "auto",
          px: { xs: 2, md: 3 },
          py: { xs: 4, md: 6 },
        }}
      >
        <Grid container spacing={4}>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Typography variant="h6" color="white" sx={{ fontWeight: 700 }} gutterBottom>
              {business.name}
            </Typography>
            <Typography variant="body2" color="white" sx={{ opacity: 0.8 }}>
              {business.about[0]}
            </Typography>
            <Stack direction="row" spacing={1.25} sx={{ mt: 2 }}>
              <SocialIconButton platform="facebook" href={business.facebookUrl} businessName={business.name} />
              <SocialIconButton platform="instagram" href={business.instagramUrl} businessName={business.name} />
            </Stack>
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Typography variant="h6" color="white" sx={{ fontWeight: 700 }} gutterBottom>
              Services
            </Typography>
            <Stack spacing={0.75}>
              {serviceCatalog.slice(0, 6).map((service) => (
                <Typography
                  key={service.slug}
                  component={RouterLink}
                  to={service.route}
                  viewTransition
                  variant="body2"
                  color="white"
                  sx={{ opacity: 0.8, textDecoration: "none", "&:hover": { opacity: 1 } }}
                >
                  {service.name}
                </Typography>
              ))}
            </Stack>
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <Typography variant="h6" color="white" sx={{ fontWeight: 700 }} gutterBottom>
              Visit Us
            </Typography>
            <Stack spacing={1.25}>
              <Stack direction="row" spacing={1} sx={{ alignItems: "flex-start" }}>
                <PlaceIcon fontSize="small" sx={{ mt: 0.25 }} />
                <Typography
                  component="a"
                  href={business.mapDirectionsUrl}
                  target="_blank"
                  rel="noreferrer"
                  variant="body2"
                  color="white"
                  sx={{ opacity: 0.8, textDecoration: "none" }}
                >
                  {business.address}
                </Typography>
              </Stack>
              <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
                <PhoneIcon fontSize="small" />
                <Typography
                  component="a"
                  href={business.phoneHref}
                  variant="body2"
                  color="white"
                  sx={{ opacity: 0.8, textDecoration: "none" }}
                >
                  {business.phone}
                </Typography>
              </Stack>
              <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
                <EmailIcon fontSize="small" />
                <Typography
                  component="a"
                  href={business.emailHref}
                  variant="body2"
                  color="white"
                  sx={{ opacity: 0.8, textDecoration: "none" }}
                >
                  {business.email}
                </Typography>
              </Stack>
              <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
                <ScheduleIcon fontSize="small" />
                <Typography variant="body2" color="white" sx={{ opacity: 0.8 }}>
                  {business.hours}
                </Typography>
              </Stack>
            </Stack>
          </Grid>
        </Grid>

        <Divider sx={{ borderColor: "rgba(255,255,255,0.15)", my: 3 }} />

        <Typography variant="caption" color="white" sx={{ opacity: 0.6 }}>
          © {new Date().getFullYear()} {business.name}. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
}
